import { ACTIVITIES } from "@/app/calculator/constants/calculatorData";
import { OptionButton, StepLabel } from "./Ui";
import { Briefcase, Monitor, ShoppingCart, Package, Coffee, Hammer,  } from "lucide-react";

// Icons for each activity
const ICONS = {
  consulting: <Briefcase size={18} />,
  tech: <Monitor size={18} />,
  ecommerce: <ShoppingCart size={18} />,
  trading: <Package size={18} />,
  food: <Coffee size={18} />,
  construction: <Hammer size={18} />,
};

export function StepActivity({ value, onChange }) {
  return (
    <div className="space-y-5">

      {/* Header */}
      <StepLabel
        tag="Activity"
        title="What type of business are you setting up?"
        description="Choose the category that best describes your business activity."
      />

      {/* Scroll Area */}
      <div className="
        max-h-[300px] sm:max-h-[340px]
        overflow-y-auto
        pr-2 sm:pr-3
        custom-scrollbar
        rounded-xl
      ">

        <div className="space-y-2 sm:space-y-3 py-16 sm:py-20">

          {ACTIVITIES.map((act) => (
            <OptionButton
              key={act.id}
              id={act.id}
              label={act.label}
              sub={act.sub}
              icon={ICONS[act.id]}
              selected={value === act.id}
              onClick={onChange}
            />
          ))}

        </div>

      </div>
    </div>
  );
}
